const tabs = {
  RecruitmentEvaluationsList: () => import('@/views/recruitment/RecruitmentEvaluationsList'),
  RecruitmentEvaluation: () => import('@/views/recruitment/RecruitmentEvaluation'),
  RecruitmentEvaluationView: () => import('@/views/recruitment/RecruitmentEvaluationView'),
  RecruitmentEvaluationAnswerReport: () => import('@/views/recruitment/FilterEvaluationAnswers')
}

const state = {
  currentRecruitmentEvaluationTab: tabs.RecruitmentEvaluationsList,
  tabs
}

const mutations = {
  SET_TABS: (state, tab) => {
    state.currentRecruitmentEvaluationTab = state.tabs[tab]
  }
}

const actions = {
  setRecruitmentEvaluationTabs({ commit }, tab) {
    commit('SET_TABS', tab)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
